import React from 'react';
import { CrmSelect, CrmTextarea, CrmDateInput } from '../ui/CrmFormControls';
import { useSettings } from '../../context/SettingsContext';
import { getGlobalDateFormat } from '../../utils/dateFormatter';

function InvoiceContactSection({
  leadId,
  setLeadId,
  leads,
  invoiceDate,
  setInvoiceDate,
  dueDate,
  setDueDate,
  notes,
  setNotes,
  readOnly = false,
  dateLabel = 'Invoice date',
}) {
  const { settings } = useSettings();
  const dateFormat = settings?.date_format || getGlobalDateFormat();
  const selectedLead = leads.find((lead) => String(lead.id) === String(leadId));

  if (readOnly) {
    return <div className="workspace-document-fields">
      <div><span>Customer</span><strong>{selectedLead ? `${selectedLead.first_name || ''} ${selectedLead.last_name || ''}`.trim() : '—'}</strong></div>
      <div><span>{dateLabel}</span><strong>{invoiceDate || '—'}</strong></div>
      <div><span>Due date</span><strong>{dueDate || '—'}</strong></div>
      <div className="workspace-document-fields__wide"><span>Notes</span><strong>{notes || '—'}</strong></div>
    </div>;
  }

  return <div className="workspace-document-form">
    <CrmSelect label="Customer" required value={leadId} onChange={(event) => setLeadId(event.target.value)}>
      <option value="">Select customer</option>
      {leads.map((lead) => <option key={lead.id} value={lead.id}>{`${lead.first_name || ''} ${lead.last_name || ''}`.trim() || lead.company_name || `Contact #${lead.id}`}</option>)}
    </CrmSelect>
    <CrmDateInput label={dateLabel} required value={invoiceDate} dateFormat={dateFormat} onChange={setInvoiceDate} />
    <CrmDateInput label="Due date" value={dueDate} dateFormat={dateFormat} onChange={setDueDate} />
    <CrmTextarea className="workspace-document-form__wide" label="Notes" value={notes} onChange={(event) => setNotes(event.target.value)} rows={4} />
  </div>;
}

export default InvoiceContactSection;
